<template>
	<app-page>
		<app-heading :title="isNew ? 'New Area' : area.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'market-areas' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Name"
					v-model="area.name"
					required
					:errors="errors.name"
				/>
				<input-select
					label="City"
					:items="cities"
					v-model="area.market_city"
					required
					:errors="errors.market_city"
				/>
				<input-textarea
					label="Heading 2 (Website)"
					v-model="area.heading2"
					required
					:errors="errors.heading2"
				/>
				<input-textarea
					label="Heading 3 (Website)"
					v-model="area.heading3"
					required
					:errors="errors.heading3"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.area = await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('areas')
					.to(this.id)
					.get()
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}

		this.cities = await this.$ravello.graphql('cities')
			.parent(this.$ravello.graphql('market', this.marketId))
			.datasource()
			.sort('name')
			.query()

		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			area: {
				name: '',
				market_city: null,
				heading2: '',
				heading3: '',
			},
			cities: [],
			errors: {},
		}
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
		id() {
			return this.$route.params.area
		},
		isNew() {
			return this.id === 'new'
		},
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')

			const request = this.$ravello.request()
				.v(2)
				.to('markets')
				.to(this.marketId)
				.to('areas')

			const payload = {
				name: this.area.name,
				market_city: this.area.market_city,
				heading2: this.area.heading2,
				heading3: this.area.heading3,
			}

			try {
				if (this.isNew) {
					await request.create(payload)
				} else {
					await request
						.to(this.id)
						.update(payload)
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Area successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'market-areas' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
